import { useEffect } from "react";
import "@/App.css";

// Landing Page Components
import { Navigation } from "./components/landing/Navigation";
import { Hero } from "./components/landing/Hero";
import { About } from "./components/landing/About";
import { Courses } from "./components/landing/Courses";
import { Differentials } from "./components/landing/Differentials";
import { Results } from "./components/landing/Results";
import { Testimonials } from "./components/landing/Testimonials";
import { Contact } from "./components/landing/Contact";
import { Footer } from "./components/landing/Footer";
import { WhatsAppButton } from "./components/landing/WhatsAppButton";

function App() {
  useEffect(() => {
    // Update page title and meta for SEO
    document.title = "Ritha Barreto Academy | Formação em Estética Avançada";
    
    // Add meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Cursos e capacitação profissional em estética avançada com método prático e resultados reais. Torne-se referência no mercado.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Cursos e capacitação profissional em estética avançada com método prático e resultados reais. Torne-se referência no mercado.';
      document.head.appendChild(meta);
    }

    // Add keywords meta
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      const keywords = document.createElement('meta');
      keywords.name = 'keywords';
      keywords.content = 'curso estética avançada, formação estética profissional, treinamento estética, micropigmentação, protocolos estéticos, lip blush, jato de plasma, massagem modeladora';
      document.head.appendChild(keywords);
    }
  }, []);

  return (
    <div className="App min-h-screen bg-dark" data-testid="app-container">
      {/* Noise texture overlay */}
      <div className="noise-overlay" />
      
      {/* Navigation */}
      <Navigation />
      
      {/* Main Content */}
      <main>
        <Hero />
        <About />
        <Courses />
        <Differentials />
        <Results />
        <Testimonials />
        <Contact />
      </main>
      
      {/* Footer */}
      <Footer />
      
      {/* Floating WhatsApp Button */}
      <WhatsAppButton />
    </div>
  );
}

export default App;
